import {useEffect, useRef, useState} from "react";

import {useSelector} from "react-redux";
import {useTimer} from "react-timer-hook";

export const useChatTime = (duration) => {
  const expiryTimestamp = new Date(Date.now() + duration);

  const {totalSeconds, start, restart} = useTimer({
    expiryTimestamp,
    autoStart: false,
    onExpire: () => console.warn("onExpire called"),
  });

  const [chatTime, setChatTimeState] = useState(null);
  const {messages} = useSelector((state) => state.ml.chat);
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (messages.length === 0) {
      hasStartedRef.current = false;
      return;
    }

    if (!hasStartedRef.current) {
      start();
      hasStartedRef.current = true;
    }
  }, [messages.length, start]);

  useEffect(() => {
    if (!hasStartedRef.current) return;
    setChatTimeState(totalSeconds * 1000);
  }, [totalSeconds]);

  if (duration <= 0) {
    console.log(duration);
    console.warn("Duration must be a positive number");

    return [null, () => {}, () => {}];
  }

  return [chatTime, setChatTimeState, restart];
};
